import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { AnalyticsEvents, analytics } from "common/analytics";
import { useTranslation } from "common/locales";
import { Field, getAllFieldsForAnimalGroupIdFromArray, useFields } from "model";
import { useMemo, useState } from "react";
import { openMoveInDialog } from "stores";

export default function SetCurrentFieldDialog({
  animalGroupId,
  open,
  close,
}: SetCurrentFieldDialogProps) {
  const [field, setField] = useState<Field | null>(null);
  // Use React Query for fields data
  const { data: allFields = [] } = useFields();
  const fields = useMemo(
    () => getAllFieldsForAnimalGroupIdFromArray(allFields, animalGroupId),
    [allFields, animalGroupId]
  );
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t("setCurrentFieldDialog.title")}</DialogTitle>
      <DialogContent sx={{ minWidth: 280 }}>
        <Autocomplete
          disabled={fields.length === 0}
          options={fields}
          getOptionLabel={(field) => field.name}
          style={{ width: "100%" }}
          onChange={(_, newValue) => setField(newValue)}
          value={field}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t(
                fields.length === 0
                  ? "setCurrentFieldDialog.noFieldsLabel"
                  : "assignFieldDialog.inputLabel"
              )}
              variant="outlined"
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {t("settings.button.close")}
        </Button>
        <Button
          disabled={fields.length === 0 || !field}
          onClick={setCurrentField}
          color="primary"
        >
          {t("setCurrentFieldDialog.button")}
        </Button>
      </DialogActions>
    </Dialog>
  );

  function onClose() {
    setField(null);
    close();
  }

  function setCurrentField() {
    analytics.track(AnalyticsEvents.ANIMAL_GROUP_FIELD_SET);
    if (field) {
      setField(null);
      close();
      openMoveInDialog(field, undefined);
    }
  }
}

type SetCurrentFieldDialogProps = {
  open: boolean;
  close: () => void;
  animalGroupId: string;
};
